import * as React from 'react';
import MetaTags from 'components/MetaTags';
import { notFoundConstants, robotsConstants } from 'commons/constants';
import { getAppSettings } from 'utils/privateLabel/index';
import { useSelector } from 'react-redux';
import NotFoundWrapper from './NotFound.style';

const NotFound: React.FC = () => {
  const { data: globalPartner } = useSelector((state: any) => state.partnerInstance.globalPartner);

  return (
    <NotFoundWrapper>
      <MetaTags
        title={(getAppSettings() || globalPartner)?.companyName}
        robots={robotsConstants.NOINDEX_NOFOLLOW}
      />
      <span className='text-school-graph-gender-subtitle not-found__title'>
        {notFoundConstants.NOT_FOUND}
      </span>
      <span className='text-content-section-head-blue not-found__sub-title'>
        {notFoundConstants.TEXT}
      </span>
    </NotFoundWrapper>
  );
};

export default NotFound;
